import './component.scss'
import { Controller } from 'stimulus';
import './images/campaign_client_search_kaeru1.png'
import './images/campaign_client_search_kaeru2.png'
import './images/campaign_process1.png'
import './images/campaign_process2.png'
import './images/campaign_step1.png'
import './images/campaign_step2.png'
import './images/campaign_step3.png'
import './images/campaign_step4.png'
import './images/campaign_step1_kaeru.png'
import './images/campaign_step2_kaeru.png'
import './images/campaign_step3_kaeru.png'
import './images/campaign_step4_kaeru.png'
import './images/cashback_campaign_mv_pc.png'
import './images/cashback_campaign_mv_tb.png'
import './images/cashback_campaign_mv_sp.png'
import './images/process_number1.png'
import './images/process_number2.png'

// FAQアコーディオンコントローラー
window.Stimulus.register(
  'cashback-faq',
  class extends Controller {
    static targets = ['item', 'answer'];

    toggle(event) {
      const button = event.currentTarget;
      const item = button.closest('[data-cashback-faq-target="item"]');

      // Toggle current item
      if (item.classList.contains('is-active')) {
        item.classList.remove('is-active');
      } else {
        // Open current item
        item.classList.add('is-active');
      }
    }
  }
)

// 会社検索モーダルコントローラー
window.Stimulus.register(
  'nurikae-client-search-modal',
  class extends Controller {
    connect() {
      // 初期スクロール位置を保存
      this.scrollPosition = 0;
      // 現在の表示状態を管理
      this.currentSlide = 'regions';
    }

    // エリアモーダルを開く
    openAreaModal() {
      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-area-modal');
      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-area-modal-desktop');

      const modal = modalSp || modalDesktop;
      if (!modal) return;

      // スクロール位置を保存
      this.scrollPosition = window.scrollY;

      // bodyのスクロールを無効化
      document.body.style.overflow = 'hidden';

      // 初期状態に戻す（地域リスト表示）
      this.showRegions();

      // SP版の場合
      if (modalSp) {
        const overlay = modalSp.querySelector('.cashback-area-modal__overlay');
        const content = modalSp.querySelector('.cashback-area-modal__content');

        if (overlay && content) {
          modalSp.classList.add('cashback-area-modal--active');
          overlay.classList.add('cashback-area-modal__overlay--active');
          content.classList.add('cashback-area-modal__content--active');
        }
      }

      // PC/TB版の場合
      if (modalDesktop) {
        const overlay = modalDesktop.querySelector('.cashback-area-modal-desktop__overlay');
        const content = modalDesktop.querySelector('.cashback-area-modal-desktop__content');

        if (overlay && content) {
          modalDesktop.classList.add('cashback-area-modal-desktop--active');
          overlay.classList.add('cashback-area-modal-desktop__overlay--active');
          content.classList.add('cashback-area-modal-desktop__content--active');
        }
      }
    }

    // エリアモーダルを閉じる
    closeAreaModal() {
      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-area-modal');
      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-area-modal-desktop');

      // SP版を閉じる
      if (modalSp) {
        const overlay = modalSp.querySelector('.cashback-area-modal__overlay');
        const content = modalSp.querySelector('.cashback-area-modal__content');

        if (overlay && content) {
          overlay.classList.remove('cashback-area-modal__overlay--active');
          content.classList.remove('cashback-area-modal__content--active');

          setTimeout(() => {
            modalSp.classList.remove('cashback-area-modal--active');
            document.body.style.overflow = '';
            window.scrollTo(0, this.scrollPosition);
            this.showRegions();
          }, 300);
        }
      }

      // PC/TB版を閉じる
      if (modalDesktop) {
        const overlay = modalDesktop.querySelector('.cashback-area-modal-desktop__overlay');
        const content = modalDesktop.querySelector('.cashback-area-modal-desktop__content');

        if (overlay && content) {
          overlay.classList.remove('cashback-area-modal-desktop__overlay--active');
          content.classList.remove('cashback-area-modal-desktop__content--active');

          setTimeout(() => {
            modalDesktop.classList.remove('cashback-area-modal-desktop--active');
            document.body.style.overflow = '';
            window.scrollTo(0, this.scrollPosition);
            this.showRegions();
          }, 300);
        }
      }
    }

    // 都道府県表示に遷移
    showPrefectures(event) {
      const regionId = event.currentTarget.dataset.regionId;

      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-area-modal');
      if (modalSp) {
        this.displayPrefecturesForRegion(regionId, modalSp, 'cashback-area-modal');

        const regionsSlide = modalSp.querySelector('.js-cashback-area-modal-regions-slide');
        const prefecturesSlide = modalSp.querySelector('.js-cashback-area-modal-prefectures-slide');
        const backButton = modalSp.querySelector('.js-cashback-area-modal-back-button');

        if (regionsSlide && prefecturesSlide) {
          regionsSlide.classList.add('slide-to-prefectures');
          prefecturesSlide.classList.add('slide-to-prefectures');
        }

        if (backButton) {
          backButton.classList.add('cashback-area-modal__back-button--visible');
        }
      }

      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-area-modal-desktop');
      if (modalDesktop) {
        this.displayPrefecturesForRegion(regionId, modalDesktop, 'cashback-area-modal-desktop');

        const regionsSlide = modalDesktop.querySelector('.js-cashback-area-modal-desktop-regions-slide');
        const prefecturesSlide = modalDesktop.querySelector('.js-cashback-area-modal-desktop-prefectures-slide');
        const backButton = modalDesktop.querySelector('.js-cashback-area-modal-desktop-back-button');

        if (regionsSlide && prefecturesSlide) {
          regionsSlide.classList.add('slide-to-prefectures');
          prefecturesSlide.classList.add('slide-to-prefectures');
        }

        if (backButton) {
          backButton.classList.add('cashback-area-modal-desktop__back-button--visible');
        }
      }

      this.currentSlide = 'prefectures';
    }

    // 地域選択に戻る
    showRegions() {
      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-area-modal');
      if (modalSp) {
        const prefectureGroups = modalSp.querySelectorAll('.cashback-area-modal__prefecture-group');
        prefectureGroups.forEach(group => {
          group.classList.remove('cashback-area-modal__prefecture-group--active');
        });

        const regionsSlide = modalSp.querySelector('.js-cashback-area-modal-regions-slide');
        const prefecturesSlide = modalSp.querySelector('.js-cashback-area-modal-prefectures-slide');
        const backButton = modalSp.querySelector('.js-cashback-area-modal-back-button');

        if (regionsSlide && prefecturesSlide) {
          regionsSlide.classList.remove('slide-to-prefectures');
          prefecturesSlide.classList.remove('slide-to-prefectures');
        }

        if (backButton) {
          backButton.classList.remove('cashback-area-modal__back-button--visible');
        }
      }

      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-area-modal-desktop');
      if (modalDesktop) {
        const prefectureGroups = modalDesktop.querySelectorAll('.cashback-area-modal-desktop__prefecture-group');
        prefectureGroups.forEach(group => {
          group.classList.remove('cashback-area-modal-desktop__prefecture-group--active');
        });

        const regionsSlide = modalDesktop.querySelector('.js-cashback-area-modal-desktop-regions-slide');
        const prefecturesSlide = modalDesktop.querySelector('.js-cashback-area-modal-desktop-prefectures-slide');
        const backButton = modalDesktop.querySelector('.js-cashback-area-modal-desktop-back-button');

        if (regionsSlide && prefecturesSlide) {
          regionsSlide.classList.remove('slide-to-prefectures');
          prefecturesSlide.classList.remove('slide-to-prefectures');
        }

        if (backButton) {
          backButton.classList.remove('cashback-area-modal-desktop__back-button--visible');
        }
      }

      this.currentSlide = 'regions';
    }

    // 指定した地域の都道府県を表示
    displayPrefecturesForRegion(regionId, modal, prefix) {
      if (!modal) return;

      // すべての都道府県グループを非表示
      const prefectureGroups = modal.querySelectorAll(`.${prefix}__prefecture-group`);
      prefectureGroups.forEach(group => {
        group.classList.remove(`${prefix}__prefecture-group--active`);
      });

      // 指定した地域の都道府県グループを表示
      const targetGroup = modal.querySelector(`.${prefix}__prefecture-group[data-region-id="${regionId}"]`);
      if (targetGroup) {
        targetGroup.classList.add(`${prefix}__prefecture-group--active`);
      }
    }

    // 会社名検索モーダルを開く
    openCompanyNameModal() {
      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-company-modal');
      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-company-modal-desktop');

      const modal = modalSp || modalDesktop;
      if (!modal) return;

      // スクロール位置を保存
      this.scrollPosition = window.scrollY;

      // bodyのスクロールを無効化
      document.body.style.overflow = 'hidden';

      // SP版の場合
      if (modalSp) {
        const overlay = modalSp.querySelector('.cashback-company-modal__overlay');
        const content = modalSp.querySelector('.cashback-company-modal__content');

        if (overlay && content) {
          modalSp.classList.add('cashback-company-modal--active');
          overlay.classList.add('cashback-company-modal__overlay--active');
          content.classList.add('cashback-company-modal__content--active');
        }
      }

      // PC/TB版の場合
      if (modalDesktop) {
        const overlay = modalDesktop.querySelector('.cashback-company-modal-desktop__overlay');
        const content = modalDesktop.querySelector('.cashback-company-modal-desktop__content');

        if (overlay && content) {
          modalDesktop.classList.add('cashback-company-modal-desktop--active');
          overlay.classList.add('cashback-company-modal-desktop__overlay--active');
          content.classList.add('cashback-company-modal-desktop__content--active');
        }
      }
    }

    // 会社名検索モーダルを閉じる
    closeCompanyNameModal() {
      // SP版のモーダル
      const modalSp = document.querySelector('.cashback-company-modal');
      // PC/TB版のモーダル
      const modalDesktop = document.querySelector('.cashback-company-modal-desktop');

      // SP版を閉じる
      if (modalSp) {
        const overlay = modalSp.querySelector('.cashback-company-modal__overlay');
        const content = modalSp.querySelector('.cashback-company-modal__content');

        if (overlay && content) {
          overlay.classList.remove('cashback-company-modal__overlay--active');
          content.classList.remove('cashback-company-modal__content--active');

          setTimeout(() => {
            modalSp.classList.remove('cashback-company-modal--active');
            document.body.style.overflow = '';
            window.scrollTo(0, this.scrollPosition);
          }, 300);
        }
      }

      // PC/TB版を閉じる
      if (modalDesktop) {
        const overlay = modalDesktop.querySelector('.cashback-company-modal-desktop__overlay');
        const content = modalDesktop.querySelector('.cashback-company-modal-desktop__content');

        if (overlay && content) {
          overlay.classList.remove('cashback-company-modal-desktop__overlay--active');
          content.classList.remove('cashback-company-modal-desktop__content--active');

          setTimeout(() => {
            modalDesktop.classList.remove('cashback-company-modal-desktop--active');
            document.body.style.overflow = '';
            window.scrollTo(0, this.scrollPosition);
          }, 300);
        }
      }
    }
  }
)

// 会社名検索コントローラー
window.Stimulus.register(
  'cashback-company-search',
  class extends Controller {
    static targets = ['input', 'dropdown', 'message', 'results', 'clearButton'];

    connect() {
      this.searchTimeout = null;
    }

    handleInput(event) {
      const query = event.target.value.trim();

      // 入力が空またはスペースのみの場合
      if (query.length === 0) {
        this.hideDropdown();
        return;
      }

      // 2文字未満の場合
      if (query.length < 2) {
        this.showMessage('2文字以上入力してください');
        return;
      }

      // 既存のタイマーをクリア
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // 300ms後に検索を実行
      this.searchTimeout = setTimeout(() => {
        this.searchCompanies(query);
      }, 300);
    }

    handleFocus() {
      // フォーカス時にドロップダウンを表示（入力内容がある場合）
      const query = this.inputTarget.value.trim();
      if (query.length >= 2) {
        this.dropdownTarget.classList.add('is-show');
      }
    }

    handleBlur() {
      // ブラー時は少し遅延させてドロップダウンを隠す（クリックイベントが先に発火するように）
      setTimeout(() => {
        this.hideDropdown();
      }, 200);
    }

    async searchCompanies(query) {
      try {
        // ローディング表示
        this.showMessage('検索中...');

        const encodedQuery = encodeURIComponent(query);
        const response = await fetch(`/api/clients/search?name=${encodedQuery}`);

        if (!response.ok) {
          throw new Error('検索に失敗しました');
        }

        const data = await response.json();

        // 結果を表示（APIは直接配列を返す）
        this.displayResults(data || []);
      } catch (error) {
        console.error('Search error:', error);
        this.showMessage('検索中にエラーが発生しました');
      }
    }

    displayResults(clients) {
      // メッセージを非表示
      this.messageTarget.style.display = 'none';

      // 結果をクリア
      this.resultsTarget.innerHTML = '';

      if (clients.length === 0) {
        this.messageTarget.textContent = '該当する会社が見つかりませんでした';
        this.messageTarget.style.display = 'block';
        this.dropdownTarget.classList.add('is-show');
        return;
      }

      // 会社リストを表示
      clients.forEach((client) => {
        const item = this.createCompanyItem(client);
        this.resultsTarget.appendChild(item);
      });

      this.dropdownTarget.classList.add('is-show');
    }

    createCompanyItem(client) {
      const item = document.createElement('div');

      // デバイスに応じたクラス名を決定
      const isSp = this.element.classList.contains('cashback-company-modal__body');
      item.className = isSp
        ? 'cashback-company-modal__company-item'
        : 'cashback-company-modal-desktop__company-item';

      // XSS対策のためHTMLエスケープ
      const escapedName = this.escapeHtml(client.name);
      item.innerHTML = `<span>${escapedName}</span>`;

      // クリックイベント
      item.addEventListener('click', () => {
        this.selectCompany(client);
      });

      return item;
    }

    selectCompany(client) {
      // 会社詳細ページへ遷移
      const url = `/company/${client.id}?from=campaign_cashback`;
      window.location.href = url;
    }

    showMessage(message) {
      this.messageTarget.textContent = message;
      this.messageTarget.style.display = 'block';
      this.resultsTarget.innerHTML = '';
      this.dropdownTarget.classList.add('is-show');
    }

    hideDropdown() {
      this.dropdownTarget.classList.remove('is-show');
    }

    clearInput() {
      // 入力フィールドをクリア
      this.inputTarget.value = '';
      this.inputTarget.focus();

      // ドロップダウンを非表示
      this.hideDropdown();

      // 結果をクリア
      this.resultsTarget.innerHTML = '';
      this.messageTarget.textContent = '会社名を2文字以上入力してください';
      this.messageTarget.style.display = 'block';
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }
)
